import getElement from 'config/navigation/util/get-element';

import {Route} from 'react-router-dom';
import {SubRouteProps} from '..';
import getModalRoute from './get-modal-route';

const getSubRoute = ({
  path,
  element,
  permissions,
  modals,
  hideDrawer,
  wrapper,
  exactPermission,
}: SubRouteProps) => (
  <Route
    key={path}
    element={
      element &&
      getElement({
        element,
        permissions: exactPermission
          ? permissions?.map((permission) => ({
              name: permission,
              exactPermission,
            }))
          : permissions,
        hideDrawer,
        wrapper,
      })
    }
    {...{path}}>
    {modals && modals.map(getModalRoute)}
  </Route>
);

export default getSubRoute;
